import { Box, Collapse } from '@mui/material'
import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import SanitizeHtml from '../Base/SanitizeHtml/SanitizeHtml'
import ExtrasApp from '../Booking/components/ExtrasApp'
import constants from '../../../js/lib/constants'
import * as lib from '../../../js/lib/lib'
import { setStep } from '../../../js/lib/redux/slices/booking'
import Terms from '../Terms'
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import Upsell from '../Booking/components/Upsell'
import Alert from '../Base/Alert'
import isTransmissionAuto from '../../../js/helpers/isTransmissionAuto'

const Inpath = () => {
  const { configuration, dictionary, records } =
    window.bookingData || window.inpathData

  const { pickUpDetails, dropOffDetails } = window.inpathData || {}

  const [isLoading, setIsLoading] = useState(false)
  const [showIncludesList, setShowIncludesList] = useState(false)
  const [alertMessages, setAlertMessages] = useState([])
  const { selectedVehicle, isPrepaid } = useSelector((state) => state.booking)
  const dispatch = useDispatch()
  const { brands } = records
  const { car, brandName } = selectedVehicle || {}

  const {
    isGuaranteed,
    modelImage,
    model,
    passengers,
    bigLuggage,
    smallLuggage,
    categories,
    ac,
    charging,
    prepaidPrice,
    returnPrice,
    name: groupName,
    acriss,
    upsellGroup,
  } = car || {}

  const prepaidIncludes = prepaidPrice?.prepaidIncludes.split(',')
  const returnIncludes = returnPrice?.returnIncludes.split(',')

  const includesList =
    prepaidIncludes?.length > 0 ? prepaidIncludes : returnIncludes

  const brandLogo = brands?.find(
    (brand) => brand.brandCode === brandName
  )?.brandLogo

  const handleBooking = () => {
    dispatch(setStep(constants.booking.pageNumber.vehicles))
  }

  const termsSchema = z.object({
    terms: z.boolean().refine((val) => val === true, {
      message: dictionary.termsRequiredText,
    }),
  })

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(termsSchema),
    defaultValues: { terms: false },
  })

  const handleSuccess = () => {
    setAlertMessages([])
    setIsLoading(false)
  }

  const handleError = (messages) => {
    setAlertMessages(messages)
    setIsLoading(false)

    setTimeout(() => {
      lib.scrollToError(100)
    }, 0)
  }

  const handleSetSelectedExtras = (value) => {
    window.AddCarToBasket(value)
  }

  // useEffect(() => {
  //   if (car?.upsellGroup) {
  //     upsellFetchData()
  //   }
  // }, [car])

  // useEffect(() => {
  //   dispatch(setType('inpath'))
  // }, [])

  return (
    <>
      {!!selectedVehicle && (
        <>
          <div className="page-container">
            {alertMessages.length > 0 && <Alert messages={alertMessages} />}
            {upsellGroup && (
              <Upsell
                handleSuccess={handleSuccess}
                handleError={handleError}
                dictionary={dictionary}
                pickUpDetails={pickUpDetails}
                dropOffDetails={dropOffDetails}
                inpath
              />
            )}
          </div>

          <div className="s-inpath">
            <div className="page-container">
              <div className="s-inpath__title">
                {dictionary.selectedVehicleLabel}
              </div>
              <div className="b-vehicle-card">
                <div className="b-vehicle-card__main">
                  {/* <!--left--> */}
                  <div className="b-vehicle-card__info">
                    <div className="b-vehicle-card__img">
                      <img src={modelImage} alt={model} />
                    </div>

                    <div className="b-vehicle-card__txt">
                      <div className="b-vehicle-card__head">
                        <div>
                          <div className="b-vehicle-card__brand">
                            {model}
                            {isGuaranteed && (
                              <span className="b-vehicle-card__guaranteed">
                                {dictionary.guaranteedLabel}
                              </span>
                            )}
                            {!isGuaranteed && (
                              <span>{dictionary.similarText}</span>
                            )}
                          </div>
                        </div>

                        <div className="b-vehicle-card__logo">
                          {brandLogo && <img src={brandLogo} alt={brandName} />}
                        </div>
                      </div>

                      <div className="b-vehicle-card__details">
                        <ul>
                          <li>
                            <div className="b-vehicle-card__details__passengers">
                              <i className="icon-passenger"></i>
                              {passengers} {dictionary.passengersLabel}
                            </div>
                          </li>
                          <li>
                            <div className="b-vehicle-card__details__suitcase">
                              <span className="large">
                                <i className="icon-suitcase"></i>x{bigLuggage}
                              </span>
                              <span className="small">
                                <i className="icon-suitcase"></i>x{smallLuggage}
                              </span>
                            </div>
                          </li>
                          {categories && (
                            <li>
                              <div className="b-vehicle-card__details__transmission">
                                <i className="icon-transmission"></i>
                                {isTransmissionAuto({ acriss })
                                  ? dictionary.transmissionAutomatic
                                  : dictionary.transmissionManual}
                              </div>
                            </li>
                          )}
                          <li>
                            <div className="b-vehicle-card__details__acc">
                              <i className="icon-ac"></i>
                              {ac ? dictionary.acYes : dictionary.acNo}
                            </div>
                          </li>
                          {charging && (
                            <li>
                              <div className="b-vehicle-card__details__battery">
                                <i className="icon-battery-charging"></i>
                                {charging}
                              </div>
                            </li>
                          )}
                        </ul>
                      </div>

                      <div className="b-vehicle-card__includes d-none d-lg-block">
                        {/* <!--add class open next to b-dropdown--> */}
                        <div
                          className={`b-dropdown ${
                            showIncludesList ? 'open' : ''
                          }`}>
                          <span
                            className="b-dropdown__label"
                            onClick={() => setShowIncludesList((old) => !old)}>
                            {showIncludesList
                              ? dictionary.hideIncludes
                              : dictionary.viewIncludes}
                            <i className="icon-arrow-dropdown-down"></i>
                          </span>
                          <div className="b-dropdown__body">
                            <ul>
                              {includesList?.map((item, index) => (
                                <li key={index}>
                                  <i className="icon-check"></i>
                                  {item}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="b-vehicle-card__includes d-block d-lg-none">
                      {/* <!--add class open next to b-dropdown--> */}
                      <div
                        className={`b-dropdown ${
                          showIncludesList ? 'open' : ''
                        }`}>
                        <span
                          className="b-dropdown__label"
                          onClick={() => setShowIncludesList((old) => !old)}>
                          {showIncludesList
                            ? dictionary.hideIncludes
                            : dictionary.viewIncludes}
                          <i className="icon-arrow-dropdown-down"></i>
                        </span>
                        <div className="b-dropdown__body">
                          <ul>
                            {includesList?.map((item, index) => (
                              <li key={index}>
                                <i className="icon-check"></i>
                                {item}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <!--right--> */}

                  <div className="b-vehicle-card__book">
                    <div className="b-vehicle-card__total d-none d-lg-block">
                      <div className="b-vehicle-card__book__total__label">
                        {dictionary.priceLabel}
                        {dictionary.selectedVehicleTotalLabel}
                      </div>
                      <div className="b-vehicle-card__book__total__value">
                        {lib.formatCurrency(
                          isPrepaid
                            ? prepaidPrice?.estimatedTotalCurrency
                            : returnPrice?.estimatedTotalCurrency,
                          isPrepaid
                            ? prepaidPrice?.estimatedTotal
                            : returnPrice?.estimatedTotal
                        )}
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={handleBooking}
                      title={dictionary.selectedVehicleChangeButtonLabel}>
                      {dictionary.selectedVehicleChangeButtonLabel}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="page-container">
              <form onSubmit={handleSubmit(handleBooking)}>
                <div className="s-inpath__title">{dictionary.extrasLabel}</div>
                <div className="row">
                  <div className="col-12">
                    <div className="s-extras-list">
                      <ExtrasApp
                        extrasEndpoint={configuration.endpointInpathBookNow}
                        onSetSelectedExtras={handleSetSelectedExtras}
                      />
                      <div className="s-extras-list__terms">
                        <SanitizeHtml
                          html={dictionary.extrasNoteText}></SanitizeHtml>
                        <Terms
                          endpoint={configuration.endpointTermsNConditions}
                          control={control}
                          dictionary={dictionary}
                          termsOnly={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default Inpath
